var map = {
	"./arrows/arrow_back.svg": 6367,
	"./arrows/arrow_downward.svg": 3536,
	"./arrows/arrow_drop_down.svg": 2488,
	"./arrows/arrow_drop_up.svg": 9211,
	"./arrows/arrow_forward.svg": 6841,
	"./arrows/arrow_insert.svg": 4437,
	"./arrows/arrow_left.svg": 4945,
	"./arrows/arrow_outward.svg": 1052,
	"./arrows/arrow_right.svg": 5100,
	"./arrows/arrow_upward.svg": 6531,
	"./arrows/cached.svg": 1378,
	"./arrows/height.svg": 4269,
	"./arrows/keyboard_arrow_down.svg": 6036,
	"./arrows/keyboard_arrow_left.svg": 9059,
	"./arrows/keyboard_arrow_right.svg": 5878,
	"./arrows/keyboard_arrow_up.svg": 7263,
	"./arrows/keyboard_double_arrow_left.svg": 7557,
	"./arrows/keyboard_double_arrow_right.svg": 1416,
	"./arrows/trending_down.svg": 1562,
	"./arrows/trending_up.svg": 3209,
	"./augustsays/Beep-colour.svg": 3236,
	"./augustsays/Boop-colour.svg": 7984,
	"./augustsays/Boop-colour2.svg": 2162,
	"./augustsays/Bop.svg": 5190,
	"./augustsays/beep.svg": 9063,
	"./augustsays/beep2.svg": 4231,
	"./augustsays/beep3.svg": 4054,
	"./augustsays/boop.svg": 7219,
	"./augustsays/canvasses.svg": 554,
	"./augustsays/comp.svg": 7190,
	"./augustsays/home.svg": 746,
	"./augustsays/insights.svg": 6840,
	"./augustsays/logo.svg": 2934,
	"./augustsays/textlogo.svg": 2763,
	"./augustsays/users.svg": 3505,
	"./communicate/call.svg": 485,
	"./communicate/chat.svg": 3523,
	"./communicate/chat_bubble.svg": 7156,
	"./communicate/comment.svg": 8288,
	"./communicate/drafts.svg": 6561,
	"./communicate/error.svg": 1045,
	"./communicate/help.svg": 7284,
	"./communicate/inbox.svg": 2623,
	"./communicate/info.svg": 9665,
	"./communicate/mail.svg": 2576,
	"./communicate/mode_comment.svg": 514,
	"./communicate/send.svg": 363,
	"./communicate/tooltip_2.svg": 8265,
	"./communicate/warning.svg": 6187,
	"./date_time/calendar_month.svg": 9805,
	"./date_time/calendar_today.svg": 8308,
	"./date_time/event.svg": 3848,
	"./date_time/event_available.svg": 7464,
	"./date_time/event_busy.svg": 6000,
	"./date_time/schedule.svg": 8375,
	"./date_time/update.svg": 5483,
	"./media/dark_mode.svg": 2274,
	"./media/light_mode.svg": 5194,
	"./media/opacity.svg": 3407,
	"./media/photo.svg": 7780,
	"./media/photo_camera.svg": 1734,
	"./mood/AS_Emotion_Icons_Sprite.svg": 2120,
	"./mood/AS_Emotion_Icons_Sprite_v2.svg": 1963,
	"./mood/mood.svg": 8584,
	"./mood/mood_bad.svg": 8456,
	"./mood/sentiment_calm.svg": 6126,
	"./mood/sentiment_content.svg": 994,
	"./mood/sentiment_dissatisfied.svg": 5195,
	"./mood/sentiment_excited.svg": 5059,
	"./mood/sentiment_extremely_dissatisfied.svg": 9875,
	"./mood/sentiment_frustrated.svg": 8633,
	"./mood/sentiment_neutral.svg": 6724,
	"./mood/sentiment_sad.svg": 7105,
	"./mood/sentiment_satisfied.svg": 7885,
	"./mood/sentiment_stressed.svg": 3192,
	"./mood/sentiment_very_dissatisfied.svg": 3722,
	"./mood/sentiment_very_satisfied.svg": 5758,
	"./mood/sentiment_worried.svg": 1689,
	"./mood/sick.svg": 8591,
	"./shop/bar_chart.svg": 1960,
	"./shop/book_2.svg": 1702,
	"./shop/credit_card.svg": 5726,
	"./shop/donut_large.svg": 5786,
	"./shop/package_2.svg": 6025,
	"./shop/payments.svg": 3263,
	"./shop/sell.svg": 2570,
	"./shop/shopping_bag.svg": 597,
	"./shop/shopping_cart.svg": 2683,
	"./shop/shoppingmode.svg": 851,
	"./shop/storefront.svg": 682,
	"./shop/wallet.svg": 1253,
	"./user_actions/account_circle.svg": 5977,
	"./user_actions/add.svg": 9194,
	"./user_actions/add_circle.svg": 505,
	"./user_actions/block.svg": 855,
	"./user_actions/bookmark-1.svg": 5367,
	"./user_actions/bookmark.svg": 2069,
	"./user_actions/brick.svg": 6092,
	"./user_actions/cancel.svg": 407,
	"./user_actions/check.svg": 231,
	"./user_actions/check_circle.svg": 5306,
	"./user_actions/close.svg": 3835,
	"./user_actions/collapse_all.svg": 1724,
	"./user_actions/compare_arrows.svg": 2791,
	"./user_actions/content_cut.svg": 8445,
	"./user_actions/delete.svg": 4072,
	"./user_actions/diamond.svg": 1107,
	"./user_actions/do_not_disturb_on.svg": 5644,
	"./user_actions/download.svg": 9229,
	"./user_actions/download_done.svg": 4784,
	"./user_actions/edit.svg": 7685,
	"./user_actions/favorite-1.svg": 5771,
	"./user_actions/favorite.svg": 3393,
	"./user_actions/filter_list.svg": 6518,
	"./user_actions/google.svg": 9343,
	"./user_actions/home.svg": 3992,
	"./user_actions/logout.svg": 9127,
	"./user_actions/menu.svg": 8604,
	"./user_actions/microsoft.svg": 6987,
	"./user_actions/more_horiz.svg": 3401,
	"./user_actions/more_vert.svg": 3456,
	"./user_actions/nearby.svg": 8524,
	"./user_actions/open_in_new.svg": 610,
	"./user_actions/open_in_new_down.svg": 9781,
	"./user_actions/progress_activity.svg": 2192,
	"./user_actions/search.svg": 3297,
	"./user_actions/splitscreen_left.svg": 3097,
	"./user_actions/tune.svg": 9487,
	"./user_actions/upload.svg": 3930,
	"./user_actions/visibility.svg": 1869,
	"./user_actions/visibility_off.svg": 3423
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4078;